module.exports = __webpack_public_path__ + "img/google_play btn.2869e87f.png";